var _g, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMeetingsToday(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "discussion",
    xmlns: "http://www.w3.org/2000/svg",
    width: 76.178,
    height: 79,
    viewBox: "0 0 76.178 79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_47263",
    "data-name": "Group 47263",
    transform: "translate(22.086 35.891)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2751",
    "data-name": "Ellipse 2751",
    cx: 8.649,
    cy: 8.649,
    rx: 8.649,
    ry: 8.649,
    transform: "matrix(0.34, -0.94, 0.94, 0.34, 4.902, 16.26)",
    fill: "#ffd6bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54444",
    "data-name": "Path 54444",
    d: "M187.936,382.81a16,16,0,0,0-32.006,0Z",
    transform: "translate(-155.93 -345.478)",
    fill: "#ffda2d",
    fillRule: "evenodd"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_47264",
    "data-name": "Group 47264",
    transform: "translate(44.213 42.835)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2752",
    "data-name": "Ellipse 2752",
    cx: 8.649,
    cy: 8.649,
    rx: 8.649,
    ry: 8.649,
    transform: "matrix(0.987, -0.16, 0.16, 0.987, 6.046, 2.768)",
    fill: "#ffd6bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54445",
    "data-name": "Path 54445",
    d: "M326.259,418.092a16,16,0,0,0-31.962,0,.8.8,0,0,0,.8.841h30.365a.8.8,0,0,0,.8-.841Z",
    transform: "translate(-294.296 -382.768)",
    fill: "#64b5f6",
    fillRule: "evenodd"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_47265",
    "data-name": "Group 47265",
    transform: "translate(0 40.785)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2753",
    "data-name": "Ellipse 2753",
    cx: 8.649,
    cy: 8.649,
    rx: 8.649,
    ry: 8.649,
    transform: "translate(4.013 14.444) rotate(-56.58)",
    fill: "#ffd6bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54446",
    "data-name": "Path 54446",
    d: "M49.788,418.092a16,16,0,0,0-31.962,0,.8.8,0,0,0,.8.841H48.99a.8.8,0,0,0,.8-.841Z",
    transform: "translate(-17.825 -380.718)",
    fill: "#64b5f6",
    fillRule: "evenodd"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_47266",
    "data-name": "Group 47266",
    transform: "translate(12.328)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54447",
    "data-name": "Path 54447",
    d: "M239.013,53.5H209.982a2.226,2.226,0,0,0-2.222,2.222V73.913a2.226,2.226,0,0,0,2.222,2.222h16.51l9.407,6.755V76.134h3.114a2.226,2.226,0,0,0,2.222-2.222V55.721a2.226,2.226,0,0,0-2.222-2.222Z",
    transform: "translate(-189.714 -46.383)",
    fill: "#64b5f6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54448",
    "data-name": "Path 54448",
    d: "M97.136,82.444h29.032a2.226,2.226,0,0,1,2.222,2.222v18.192a2.226,2.226,0,0,1-2.222,2.222h-16.51l-9.407,6.755v-6.755H97.136a2.226,2.226,0,0,1-2.222-2.222V84.666A2.226,2.226,0,0,1,97.136,82.444Z",
    transform: "translate(-94.914 -70.699)",
    fill: "#72d561",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54449",
    "data-name": "Path 54449",
    d: "M135.072,9H164.1a2.226,2.226,0,0,1,2.222,2.222V29.414a2.226,2.226,0,0,1-2.222,2.222h-16.51l-9.408,6.755V31.635h-3.114a2.226,2.226,0,0,1-2.222-2.222V11.222A2.226,2.226,0,0,1,135.072,9Z",
    transform: "translate(-126.783 -9)",
    fill: "#ffda2d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54450",
    "data-name": "Path 54450",
    d: "M167.562,44.6a1.279,1.279,0,1,1,0-2.559h20.224a1.279,1.279,0,0,1,0,2.559Zm0,5.659a1.279,1.279,0,1,1,0-2.559h20.224a1.279,1.279,0,0,1,0,2.559Zm0-11.318a1.279,1.279,0,1,1,0-2.559h20.224a1.279,1.279,0,0,1,0,2.559Z",
    transform: "translate(-154.87 -32.004)",
    fill: "#eff4f7",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeetingsToday);
export default __webpack_public_path__ + "static/media/meetings-today.d0c020093a5c509704512623d3473f32.svg";
export { ForwardRef as ReactComponent };